<app-menu-container>

  <app-loading class="app-workspace-loading" *ngIf="isLoading$ | async"></app-loading>

  <div user-menu>
    <app-user-menu></app-user-menu>
    <div class="map-controls">
      <app-map-select-style></app-map-select-style>
    </div>
  </div>

  <div context-menu>
    <app-project-list-menu *ngIf="this.projects$ | async"></app-project-list-menu>
    <app-card-error [error]="error"></app-card-error>
  </div>

  <app-map></app-map>
  <app-map-canvas></app-map-canvas>
</app-menu-container>
